/* eslint-disable array-callback-return */
import { Card, CardHeader } from "reactstrap";
import { Image } from "../../../AbstractElements";
import FileMainContent from "./FileMainContent";
import SearchBar from "../SearchBar";
import { dynamicImage } from "../../../Service/DynamicImage";
import { ToastContainer } from "react-toastify";
import { useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { FileContentButtonActions } from "./FileContentButtonActions";

const FileContent = () => {
  const { myFile, searchTerm } = useAppSelector((state) => state.filemanager);

  const fileList = myFile.filter((data) => {
    if (searchTerm == null) return data;
    if (data.name.toLowerCase().includes(searchTerm.toLowerCase())) return data
  });

  return (
    <Card>
      <CardHeader className="card-no-border pb-0">
        <div className="d-md-flex d-sm-block">
          <SearchBar />
          <FileContentButtonActions />
        </div>
      </CardHeader>
      {fileList.length ? <FileMainContent fileList={fileList} /> : <Image className="img-fluid m-auto" src={dynamicImage("search-not-found.png")} alt="image" />}
      <ToastContainer />
    </Card>
  );
};

export default FileContent;
